module.exports = __webpack_public_path__ + "img/portfolio-11.019a63ee.jpg";